import { Component, Input, OnInit, inject, Inject } from '@angular/core';
import {
  Course,
  CourseCategory,
  CourseParticipant,
} from 'TrainingTrackingDataTypes';

import { FormsModule } from '@angular/forms';
import {
  dialogData as courseDialogData,
  dialogData,
  genericDialogComponent,
} from '../genericDialog';
import { CourseService } from 'TrainingTrackingServices/course-service';
import { UserService } from 'BaseServices/user-service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CourseCategoryService } from 'TrainingTrackingServices/course-categories-service';
import { CourseParticipantsService } from 'TrainingTrackingServices/course-participants-service';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { CourseCategoryDialogComponent } from '../course-category-dialog/course-category-dialog.component';

@Component({
    selector: 'app-course-dialog',
    imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    dialogInputTitleComponent,
    DeleteButtonComponent,
    SaveButtonComponent
],
    templateUrl: './course-dialog.component.html',
    styleUrls: ['./course-dialog.component.css']
})
export class CourseDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<Course[]>>(MAT_DIALOG_DATA);
  @Input() courseData!: Course;
  tempCourseData!: Course;
  previousCourseData: Course[] = [];
  courseCategories: CourseCategory[] = [];
  courseParticipants: CourseParticipant[] = [];
  courseCategoryData!: CourseCategory;
  tempCourseCategoryData!: CourseCategory;
  previousCourseCategoryData: CourseCategory[] = [];
  courseCategoryDialog: MatDialogRef<any> | null = null;

  dialogInputTitleComponent = dialogInputTitleComponent;
  currentUser = this.userService.currentUser;
  deleteButtonComponent = DeleteButtonComponent;

  constructor(
    public override dialogRef: MatDialogRef<CourseDialogComponent>,
    private courseParticipantsService: CourseParticipantsService,
    private courseService: CourseService,
    private userService: UserService,
    private courseCategoryService: CourseCategoryService,

    @Inject(MatDialog) private dialog: MatDialog
  ) {
    super(dialogRef);

    this.courseClicked(this.data.data[0]);
  }

  ngOnInit(): void {
    //Gets all participants
    this.courseParticipantsService.getParticipants().subscribe((result) => {
      this.courseParticipants = result;
    });
    //Gets all course categories
    this.courseCategoryService.getCourseCategories().subscribe((categories) => {
      this.courseCategories = categories;
      this.courseCategories.push({ id: -1, name: '(Ny kursus kategori)' });
    });
  }

  /**
   * Validates the input of yearsValid, if it is less than 0 it will set it to 0.
   * @param value
   * @returns
   */
  validateYearsValid(value: number) {
    if (value <= 0) {
      this.courseData.yearsValid = 0;
      return true;
    } else {
      this.courseData.yearsValid = value;
      return false;
    }
  }

  /**
   * Checks if url of page ends with "Kursus/Bruger"
   * @returns
   */
  checkUrl() {
    return window.location.href.endsWith('Kursus/Bruger');
  }

  /**
   * Handles the click event on a course by assigning inputdata courseData, on the components own courseData property.
   * @param courseData
   */
  courseClicked(courseData: Course) {
    this.courseData = courseData;

    // Create a deep copy of courseData to tempCourseData
    this.tempCourseData = JSON.parse(JSON.stringify(courseData));
    this.previousCourseData = [];
  }

  /**
   * Sets components courseData property to be empty, which can be changed withing the HTML of the dialog.
   */
  createNewCourse() {
    this.courseData = {
      id: 0,
      name: '',
      description: '',
      courseLink: '',
      yearsValid: 0,
      courseCategoryId: 0
    };
  }

  /**
   * Handles the change event on the course category dropdown.
   * If the user selects "Ny kursus kategori" in the dropdown, a dialog will open where the user can create a new course category.
   */
  async onCourseCategoryChange() {
    // If the user selects "Ny kursus kategori" in the dropdown
    if (this.courseData.courseCategoryId === -1) {
      // -1 is the value for "Ny kursus kategori"
      if (!this.courseCategoryDialog) {
        this.courseCategoryDialog = this.dialog.open(
          (
            await import(
              '../course-category-dialog/course-category-dialog.component'
            )
          ).CourseCategoryDialogComponent,
          { width: '450px' }
        );

        this.courseCategoryDialog
          .afterClosed()
          .subscribe((result: number | undefined) => {
            if (result) {
              this.courseCategoryService
                .getCourseCategories()
                .subscribe((categories) => {
                  this.courseCategories = categories;
                  this.courseData.courseCategoryId = result!;
                });
            } else {
              this.courseData.courseCategoryId = 0;
            }

            this.courseCategoryDialog = null;
          });
      }
    }
  }

  /**
   * Updates the database by parsing the new Course object and original Course object to updateCourse service.
   */
saveChanges() {
 this.courseService.upsertCourse(this.courseData)
    .subscribe({
      next: (result) => {
        this.dialogRef.close(true);
      },
      
    });
  }
  /**
   * Deletes a Course if no participants are part of it, by using deleteCourse service.
   * @returns
   */
  deleteCourse() {
    if (
      !confirm(
        'Er du sikker på at du vil slette kurset ' + this.courseData.name + '?'
      )
    ) {
      return;
    }
    this.courseService.deleteCourse(this.courseData).subscribe((result) => {
      this.dialogRef.close(true);
    });
  }
}
